module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Monk Downstairs")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "monkdownstairsthe.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "application/xhtml+xml; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contents",
    attrs: {
      "id": "TOC"
    }
  }, [_c('h2', {
    staticClass: "contentsHead",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/004epigraphpage#epigraphpage"
    }
  }, [_vm._v("Epigraph")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber1"
  }, [_c('a', {
    attrs: {
      "href": "#/006part01#part01"
    }
  }, [_vm._v("Part I")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter01#chapter01"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Rebecca finally finished painting the in-law apartment on a Friday…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter02#chapter02"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("On Saturday morning Rebecca woke from a dream that she…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber1"
  }, [_c('a', {
    attrs: {
      "href": "#/009part02#part02"
    }
  }, [_vm._v("Part II")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter03#chapter03"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("The offices of Utopian Images were located five blocks south…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter04#chapter04"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Saturday dawned unpromisingly, a low sky yielding grudging light. Rebecca…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber1"
  }, [_c('a', {
    attrs: {
      "href": "#/012part03#part03"
    }
  }, [_vm._v("Part III")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter05#chapter05"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("For weeks after the gathering at Stinson Beach, Rebecca didn’t…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter06#chapter06"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Rebecca woke earlier than usual on Saturday morning, with a…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber1"
  }, [_c('a', {
    attrs: {
      "href": "#/015part04#part04"
    }
  }, [_vm._v("Part IV")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter07#chapter07"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("They made love through the afternoon, something Rebecca had not…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/017chapter08#chapter08"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("In the weeks after the fiasco with Michael Christopher, Rebecca…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/018chapter09#chapter09"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("At work on Monday morning, a dress code had been…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber1"
  }, [_c('a', {
    attrs: {
      "href": "#/019part05#part05"
    }
  }, [_vm._v("Part V")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/020chapter10#chapter10"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("At the hospital, despite the genuine urgency of the attendants,…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/021chapter11#chapter11"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Friday passed uneventfully into Saturday at the hospital, and Rebecca…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "part_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber1"
  }, [_c('a', {
    attrs: {
      "href": "#/022part06#part06"
    }
  }, [_vm._v("Part VI")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/023chapter12#chapter12"
    }
  }, [_vm._v("Chapter Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Three days later, Rebecca and Mike drove out to Phoebe’s…")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "backmatterpage_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/024backmatterpage01#backmatterpage01"
    }
  }, [_vm._v("Plus:")]), _vm._v(" Insights, Interviews, and More")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "acknowledgment_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/027acknowledgmentpage#acknowledgmentpage"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "review_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/028reviewpage#reviewpage"
    }
  }, [_vm._v("Praise")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "adcard_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/029adcardpage#adcardpage"
    }
  }, [_vm._v("Other Books by Tim Farrington")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "copyright_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/030copyrightpage#copyrightpage"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "aboutpublisher_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/031aboutpublisherpage#aboutpublisherpage"
    }
  }, [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ec3e9cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005-TOC.vue
// module id = 69
// module chunks = 0